import { config } from "../config";
import Call from "../utils/Call";

class ImprimixAPI extends Call {
  constructor() {
    super(config.IMPRIMIX_API_HOST);
  }

  header() {
    return {
      "Content-Type": "application/json",
    };
  }

  async authenticate() {
    try {
      return await this.call(
        "get",
        "/oauth/token",
        {},
        {
          Authorization: `Basic ${config.IMPRIMIX_API_TOKEN}`,
        }
      );
    } catch (error) {
      return false;
    }
  }

  async getDataById(id, token) {
    try {
      return await this.call(
        "get",
        `/voucher/uuid/${id}`,
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      );
    } catch (err) {
      return false;
    }
  }

  async getDataByNumber(number, token) {
    try {
      return await this.call(
        "get",
        `/voucher/number/${number}`,
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      );
    } catch (err) {
      return false;
    }
  }
}

export default new ImprimixAPI();
